<ng-container [formGroup]="formGroup" >
  <mat-selection-list #queueSelection id="queueSelect">
    @for (assignedQueue of assignedQueues; track assignedQueue) {
      <mat-list-option
        [selected]="assignedQueue.assigned"
        (click)="toggleQueue(assignedQueue)">
        <div mat-line>{{assignedQueue.queue.queueName}} | {{assignedQueue.queue.projectName}}</div>
      </mat-list-option>
    }
  </mat-selection-list>
  <p>
    {{'Queues selected' | translate}}: {{queueSelection.selectedOptions.selected.length}}
  </p>
</ng-container>
